import api from "./axios";

export const getInventory = (params = {}, config = {}) =>
  api.get("/inventory", { ...config, params });
export const searchInventoryProductOptions = (
  query = "",
  limit = 20,
  config = {},
) =>
  api.get("/inventory/product-options", {
    ...config,
    params: { query: query.trim() || undefined, limit },
  });
export const searchInventoryIdentityOptions = (
  query = "",
  limit = 20,
  config = {},
) =>
  api.get("/inventory/identity-options", {
    ...config,
    params: { query: query.trim() || undefined, limit },
  });
export const getLowStock = () => api.get("/inventory/low-stock");
export const getOutOfStock = () => api.get("/inventory/out-of-stock");
export const createInventory = (data) => api.post("/inventory", data);
export const updateInventory = (inventoryPublicId, data) =>
  api.patch(`/inventory/${inventoryPublicId}`, data);
export const deleteInventory = (inventoryPublicId) =>
  api.delete(`/inventory/${inventoryPublicId}`);
